export const POLL_START = 'POLL_START';
export const POLL_ERROR = 'POLL_ERROR';
export const POLL_STOP = 'POLL_STOP';

export const REQUEST_PAYROLL_STATUS = 'payroll/REQUEST_PAYROLL_STATUS'; 
export const RECEIVE_PAYROLL_STATUS = 'payroll/RECEIVE_PAYROLL_STATUS'; 